import SpotifyUserService from '@/services/api/SpotifyUserService';

export default {
  state: {
    spotifyUser: {},
  },
  mutations: {
    updateSpotifyUser(state, updatedSpotifyUser) {
      state.spotifyUser = updatedSpotifyUser;
    },
  },
  actions: {
    fetchSpotifyUser({ commit }) {
      return new Promise((resolve, reject) => {
        SpotifyUserService.fetchMe()
          .then(user => {
            commit('updateSpotifyUser', user);
            resolve(user);
          })
          .catch(error => reject(error));
      });
    },
  },
  getters: {
    spotifyUser(state) {
      return state.spotifyUser;
    },
  },
};
